import {API} from "../../../api";

const api = new API();

export function getSocket(room_hash) {
    return new WebSocket(api.ws_url + room_hash);
}
